import React from 'react';

const CraneIcon = function (props) {
  const degris = props.degris > 90 ? 90 : props.degris || 0;
  let type = degris === 0 ? '0' : degris > 0 && degris <= 80 ? 'normal' : degris > 80 ? 'danger' : '-1';
  const angles = {
    '-1': {
      transform: `rotate(0,55.821667,91.895273)`,
      fill: '#d3d3d3',
    },
    0: {
      transform: `rotate(0,55.821667,91.895273)`,
      fill: '#757575',
    },
    normal: {
      transform: `rotate(-${props.degris},55.821667,91.895273)`,
      fill: '#0066cc',
    },
    danger: {
      transform: `rotate(-90,55.821667,91.895273)`,
      fill: '#cc0000',
    },
    other: {
      transform: `rotate(0,55.821667,91.895273)`,
      fill: '#757575',
    },
  };
  return (
    <svg xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' id='svg1' width='103' height='103' version='1.1' viewBox='0 0 103 103'>
      <g id='layer2' fillOpacity='1' display='inline' transform='translate(-27.044 -17.09)'>
        <g id='g5' fill='#757575' display='inline' transform='matrix(.26458 0 0 .26458 29.096 93.066)'>
          <path id='rect1' d='M69.236 33.463h120.871v37.312H69.236z' display='inline'></path>
          <path
            id='path8'
            d='M67.79 35.828v34.553H51.63L6.532 82.466v8.936h1.022l6.943 7.65h-22.25l7.701-7.7h.905v-8.227h-3.35v-7.094l3.247-2.58-.066-8.325 2.731-3.533 3.08 2.423v6.497L39.15 48.835v-3.022z'
            display='inline'></path>
          <path
            id='path9'
            d='M191.298 35.828v34.553h16.16l45.1 12.085v8.936h-1.022l-6.943 7.65h22.249l-7.7-7.7h-.906v-8.227h3.35v-7.094l-3.246-2.58.065-8.325-2.73-3.533-3.081 2.423v6.497l-32.655-21.678v-3.022z'
            display='inline'></path>
        </g>
        <g id='g21' fill='#757575' display='inline'>
          <path id='rect20' strokeWidth='0.27' d='M56.956 111.949h13.122v1.686H56.956z' display='inline'></path>
          <path
            id='rect3'
            d='M71.237 71.322h16.722v25.176H71.237z'
            display='inline'
            transform='matrix(.26458 0 0 .26458 29.096 93.066)'></path>
          <path
            id='rect4'
            d='M88.238 71.372h16.722v25.176H88.238z'
            display='inline'
            transform='matrix(.26458 0 0 .26458 29.096 93.066)'></path>
          <path
            id='rect5'
            d='M155.237 71.322h16.722v25.176h-16.722z'
            display='inline'
            transform='matrix(.26458 0 0 .26458 29.096 93.066)'></path>
          <path
            id='rect6'
            d='M172.238 71.372h16.722v25.176h-16.722z'
            display='inline'
            transform='matrix(.26458 0 0 .26458 29.096 93.066)'></path>
        </g>
        <g id='g26' fill='#edefff' strokeWidth='0.265' display='inline' transform='matrix(.26458 0 0 .26458 29.096 93.066)'>
          <path
            id='path13'
            d='M45.7 92.347h8.253v2.261h-2.114l-1.168 2.566h19.996v4.611h7.374v-.688h-2.95v-.983s.99-.813 1.131-2.25c.202-2.035-.246-2.789-.246-2.789l-9.88-.123-.038-10.974-20.364.012Z'
            display='inline'
            opacity='1'
            style={{ mixBlendMode: 'normal' }}
            transform='matrix(3.77953 0 0 3.77953 -109.968 -351.746)'></path>
          <path
            id='path14'
            d='M66.133 84s4.987.01 7.261 3.698c2.794 4.53 2.542 7.287 2.542 7.287h-.463c-.004.05.15-2.765-2.569-6.899-2.272-3.455-6.796-3.556-6.796-3.556z'
            display='inline'
            opacity='1'
            transform='matrix(3.77953 0 0 3.77953 -109.968 -351.746)'></path>
        </g>
        <g id='g27' fill='#757575' display='inline' {...angles[type]}>
          <path id='rect26' strokeWidth='1.412' d='M55.822 82.548h66.539v6.926H55.822z' display='inline' opacity='1'></path>
          <path
            id='path26'
            strokeWidth='0.265'
            d='M121.62 88.166v-4.502h1.5l-.216-1.813h6.643l-1.51 10.044-3.618-.004-.62-3.736z'
            display='inline'
            opacity='1'></path>
        </g>
        <g id='g20' fill='#757575' display='inline' opacity='1' transform='matrix(.26458 0 0 .26458 29.096 93.066)'>
          <path id='rect2' strokeWidth='1.076' d='M74.491 16.252h82.113v16.685H74.491z' display='inline'></path>
          <path
            id='path10'
            strokeWidth='0.265'
            d='M35.491 85.686v6.084h10.185v-3.198s-2.667-.485-4.102-2.886z'
            display='inline'
            transform='matrix(3.77953 0 0 3.77953 -109.968 -351.746)'></path>
          <path
            id='path11'
            strokeWidth='0.265'
            d='M41.688 81.163h13.666L67.2 97.189H56.632l-5.653-9.734h-2.606c-.11.361-3.193 2.204-6.046-1.032-2.04-2.314-.64-5.26-.64-5.26'
            display='inline'
            style={{ mixBlendMode: 'normal' }}
            transform='matrix(3.77953 0 0 3.77953 -109.968 -351.746)'></path>
          <path
            id='path12'
            strokeWidth='0.265'
            d='m43.31 81.101 5.616.013s-.35-1.816-3.048-1.807c-2.043.007-2.568 1.794-2.568 1.794'
            display='inline'
            transform='matrix(3.77953 0 0 3.77953 -109.968 -351.746)'></path>
        </g>
      </g>
    </svg>
  );
};
//
export default CraneIcon;
